import Vue from 'vue'
import Vuex from 'vuex'
import catalogues from './modules/catalogues'
import ressources from './modules/ressources'
import champs from './modules/champs'
import context from './modules/context'
import panier from './modules/panier'

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    catalogues,
    ressources,
    champs,
    context,
    panier
  }
})
